// The coins BFF router was decommissioned along with je-client. This hook is
// retained as an inert stub so obsolete coins UI still compiles; it no longer
// fetches a balance.
export type ErrorResponse = null;

export type QueryOptions = {
  enabled?: boolean;
};

export const useFetchMyBalance = (_queryOptions?: QueryOptions) => {
  return {
    data: undefined as number | undefined,
    isError: false,
    error: null as ErrorResponse,
    isLoading: false
  };
};
